<template>
  <div class="examination">
    <div class="study">
      <div class="doT-one"></div>
      <div class="doT-two"></div>
      <div class="studyTextBox">
        <span class="studyText1">{{ $route.query.name}}</span>
        <template>
          <Button class="returnBtn" @click="returnPreviousPage">{{ $t('i.login.returnPrevious') }}</Button>
        </template>
      </div>
    </div>
    <div class="examination-content">
      <div v-for="(kind,index) in kinds" :class="getClassName1(index)" :key="index" :style="{'background-color': $route.query.color}">
        <a v-bind:href="kind.href" target="_blank" @click="Selectcourseware(kind.id,kind.inner_id,kind.name,kind.id)">
          <p>{{(kind.name)}}</p>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data(){
      return{
        kinds:[],
        level: 1,
      }
    },
    methods: {
      returnPreviousPage(){
        this.$router.back(-1)
      },
      async study() {
        let id = this.id;
        const json = await this.RequestUtil.request("/front/study?id="+id);
        if (json) {
          if (json.statusCode == this.Constants.statusCode.ok) {
            this.kinds = json.datas.kinds;
          }
        }
      },
      getClassName1(index) {
        const className1 = "kind" + (index + 1);
        return className1;
      },
      async Selectcourseware(architectureindex,inner_id,name,id) {
        if (this.level == 1) {
          this.level = 2
          this.id = id
          this.$router.replace({ name:'rule', query: { pname: name, name: name, id: id, level: 2 } })
          // this.study()
        } else {
          console.log("传过来",architectureindex)
          let type = '1';
          let pname = name;
          this.$router.push({name: 'study', query: {architectureindex: architectureindex,architecture_name:name,inner_id:inner_id,type:type,pname:pname}})
        }
      }
    },
    created() {
      this.level = this.$route.query.level
      this.id = this.$route.query.id
      this.level = this.$route.query.level
      this.study()
    }
  }
</script>

<style scoped>
  .examination{
    width: 860px;
    height: auto;
    float: left;
  }
  .examination-content{
    width: 730px;
    height: auto;
    min-height: 455px;
    margin-left: 130px;
   /* margin-top: 150px;*/
  }
  .study{
    width: 860px;
    height: 40px;
    float: left;
    /*margin-top: 120px;*/
  }
  .doT-one{
    width: 10px;
    height: 10px;
    background-color: #e50020;
    margin-left: 103px;
    float: left;
  }
  .doT-two{
    width: 10px;
    height: 10px;
    background-color: #a8a8a9;
    margin-left: -10px;
    margin-top: 20px;
    float: left;
  }
  .studyText1{
    float: left;
    display: inline;
    margin-left: 15px;
    font-size: 30px;
    margin-top: -8px;
  }
  .returnBtn{
    height: 38px;
    float: right;
    margin-right: 65px;
    background-color: #2c8df1;
    color: #fff;
  }
  .kind1,
  .kind2,
  .kind3{
    margin-top: 0px!important;
  }

  .kind1, .kind2, .kind3, .kind4, .kind5,
  .kind6, .kind7, .kind8, .kind9, .kind10,
  .kind11,.kind12,.kind13,.kind14,.kind15,
  .kind16,.kind17,.kind18,.kind19,.kind20,
  .kind21,.kind22,.kind23,.kind24,.kind25,
  .kind26,.kind27,.kind28,.kind29,.kind30
  {
    width: 210px;
    height: 160px;
    float: left;
    margin-right: 20px;
    margin-top: 20px;
    border-radius: 10px;
  }
  .content-bottom-play a{
    color: #fff;
  }
  .examination-content p{
    width: 210px;
    height: 160px;
    font-size: 18px;
    text-align: center;
    line-height: 160px;
  }
  .examination-content p:hover{
    background-color: #ee546a;
    border-radius: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/system/studyAndStudy.vue